import { DateTime } from "luxon";
import { EarthIcon } from "lucide-react";
import { useTimezoneSelect, allTimezones } from "react-timezone-select";

import { useMeetingDetails } from "../../hooks/useMeetingDetails";

const formatTimezoneLabel = (tz: string, label: string) => {
  const time = DateTime.now().setZone(tz).toFormat("h:mma").toLowerCase();
  return `${label} (${time})`;
};

export const TimezoneSelect = () => {
  const { userTimezone, setTimezone } = useMeetingDetails();
  const { options, parseTimezone } = useTimezoneSelect({
    labelStyle: "original",
    timezones: {
      ...allTimezones,
      "Asia/Manila": "Manila (Philippines)",
    },
  });

  return (
    <div className="flex items-center gap-x-3">
      <EarthIcon className="text-white" />
      <select
        value={(userTimezone as any).value}
        onChange={(e) => setTimezone(parseTimezone(e.currentTarget.value))}
        className="w-full lg:w-64 bg-[#09172e] text-sm text-white cursor-pointer outline-none"
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            className="text-white cursor-pointer"
          >
            {formatTimezoneLabel(option.value, option.label)}
          </option>
        ))}
      </select>
    </div>
  );
};
